import { useHistory } from 'react-router'
import { Col } from 'react-bootstrap'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import styles from './GoBackButton.module.scss'

interface GoBackButtonProps {
  to?: string
}

export const GoBackButton = ({ to }: GoBackButtonProps) => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Col
      lg={{ span: 2 }}
      className={`${styles.goBackWrapper}`}
      onClick={() => {
        if (to) history.push(to)
        else history.goBack()
      }}
    >
      <div className={`${styles.cardIconWrapper}`}>
        <div
          className={`${styles.iconBackground}`}
          style={{ backgroundColor: '#4C4C4C' }}
        ></div>
        <FontAwesomeIcon
          icon={faArrowLeft}
          className={`${styles.cardIcon}`}
          color={'#4C4C4C'}
        />
      </div>
      <div className={`${styles.goBackTitle}`}>
        <p>{t('viewAll.goBackButton')}</p>
      </div>
    </Col>
  )
}
